import apiClient from "lib/axios";
import type { User } from "types/auth.types";
import type { StudentProcedure } from "types/service.types";
import type { ContactForm } from "types/common.types";

export const studentService = {
  getProfile: async (): Promise<User> => {
    const { data } = await apiClient.get<User>("/student/profile");
    return data;
  },

  updateProfile: async (payload: Partial<User>): Promise<User> => {
    const { data } = await apiClient.put<User>("/student/profile", payload);
    return data;
  },

  getProcedures: async (): Promise<StudentProcedure[]> => {
    const { data } = await apiClient.get<StudentProcedure[]>(
      "/student/procedures",
    );
    return data;
  },
};

export const publicService = {
  sendContactForm: async (payload: ContactForm): Promise<void> => {
    await apiClient.post("/contact", payload);
  },

  requestAVI: async (payload: Record<string, unknown>): Promise<void> => {
    await apiClient.post("/contact", payload);
  },
};
